import { curatedBaseApi } from "./baseApi";
import { getAllCaseStudyIndustryQs, getCaseStudyFromIndustryQs, getCaseStudyFromSlugQs, getCaseStudyIndustryQs, getPrevNextCaseStudyQs, getReadMoreCaseStudyFromIndustryAndSlugQs, NEXT_CASE_STUDY, PREVIOUS_CASE_STUDY } from "./qsFilters";

const caseStudyIndustryPath = '/case-study-industries'
const caseStudyPath = '/case-studies'
export const CMS_base_url = process.env.REACT_APP_CURATED_BASE_URL?.replace("/api", "");

export const caseStudyApi = curatedBaseApi.injectEndpoints({
  endpoints: (build) => ({
    // Get All Case Study Industries // For the main page URL '/case_studies'
    getAllCaseStudyIndustries: build.query({
      query: () => {
        return {
          url: `${caseStudyIndustryPath}?${getAllCaseStudyIndustryQs}`,
          method: 'GET',
        }
      },
      transformResponse: (response) => response.data
    }),


    // Get a Case Study Industry based on industry name
    getCaseStudyIndustry: build.query({
      query: (industryName) => {
        return {
          url: `${caseStudyIndustryPath}?${getCaseStudyIndustryQs(industryName)}`,
          method: 'GET',
        }
      },
      transformResponse: (response) => response.data
    }),


    //nameGet Case Study based on industry 
    getCaseStudyFromIndustry: build.query({
      query: ({ industryName, versionType }) => {
        return {
          url: `${caseStudyPath}?${getCaseStudyFromIndustryQs(industryName, versionType)}`,
          method: 'GET',
        }
      },
      transformResponse: (response) => response.data
    }),

    // read more case study
    getReadMoreCaseStudyFromIndustryAndSlug: build.query({
      query: ({ industryName, slug, versionType }) => {
        return {
          url: `${caseStudyPath}?${getReadMoreCaseStudyFromIndustryAndSlugQs(industryName, slug, versionType)}`,
          method: 'GET',
        }
      },
      transformResponse: (response) => response.data
    }),

    // Get Case study from slug
    getCaseStudyFromSlug: build.mutation({
      query: ({ slug, versionType, industry }) => {
        return {
          url: `${caseStudyPath}?${getCaseStudyFromSlugQs(slug, versionType, industry)}`,
          method: 'GET',
        }
      },
      transformResponse: (response) => response.data
    }),

    // gets previous case study based on date of created at of currently shown case study
    getPrevCaseStudyFromSlug: build.mutation({
      query: ({ createdAtDate, versionType, industry }) => {
        return {
          url: `${caseStudyPath}?${getPrevNextCaseStudyQs(createdAtDate, PREVIOUS_CASE_STUDY, versionType, industry)}`,
          method: 'GET',
        }
      },
    }),

    // gets next case study based on date of created at of currently shown case study
    getNextCaseStudyFromSlug: build.mutation({
      query: ({ createdAtDate, versionType, industry }) => {
        return {
          url: `${caseStudyPath}?${getPrevNextCaseStudyQs(createdAtDate, NEXT_CASE_STUDY, versionType, industry)}`,
          method: 'GET',
        }
      },
    }),
  }), overrideExisting: false
})

export const {
  useGetAllCaseStudyIndustriesQuery,
  useGetCaseStudyIndustryQuery,
  useGetCaseStudyFromIndustryQuery,
  useGetReadMoreCaseStudyFromIndustryAndSlugQuery,
  useGetCaseStudyFromSlugMutation,
  useGetPrevCaseStudyFromSlugMutation,
  useGetNextCaseStudyFromSlugMutation } = caseStudyApi